import { ImmutableObject } from 'seamless-immutable';
import { Category } from '../Categories/categories.reducer';
import { Action } from 'redux';
import { isType } from 'typescript-fsa/lib';
import { AppState } from '../../reducers';
import { updateStories, singleStoryFetched } from './stories.actions';
import * as Immutable from 'seamless-immutable';
import { Cluster } from '../Clusters/clusters.reducer';
import { MediaItem } from '../Media/media.reducer';
import { S3Video } from '../../../modules/StoryEdit/components/Stream/Editors/TileEditor';
import { Layout } from '../../../modules/StoryEdit/components/Stream/Editors/LayoutEditor';

export interface AttributeFilter {
  id?: number;
  sourceCategoryId?: number;
  attributeGroupId: number;
  attributeIds: number[];
}

export interface SourceCategory {
  id?: number;
  appConfigId?: number;
  categoryId: number;
  categoryKey?: number;
  priceFrom?: number;
  priceTo?: number;
  attributeFilters?: AttributeFilter[];
  category?: Category;
}

export interface TargetCategory {
  id?: number | string;
  category_id: number;
  sourceCategory?: Category;
  isPinned: boolean;
}

export interface StoryError {
  isWarning: boolean;
  name: string;
}

export interface AppConfig {
  id?: number;
  app_id: number;
  active_from?: string | null;
  active_to?: string | null;
  boost_from?: string | null;
  boost_to?: string | null;
  rebrushed_at?: string | null;
  is_valid?: boolean;
  is_live?: boolean;
  is_active?: boolean;
  stream_category_id?: number;
  stream_product_ids?: number[];
  brand_ids?: number[];
  idol_ids?: number[];
  product_ids?: number[];
  outfit_ids?: number[];
  sourceCategories?: SourceCategory[];
  targetCategories?: TargetCategory[];
  errors?: StoryError[];
}

export interface AdditionalResourceData {
  brandId: number;
}

export interface Element {
  id?: number;
  type: string;
  text?: { [key: string]: string };
  position: number;
  headerImageBrandId?: number | null;
  largerDesktopTeaser?: boolean;
  appImage?: MediaItem;
  mobileImage?: MediaItem;
  desktopImage?: MediaItem;
  mobileVideo?: S3Video;
  desktopVideo?: S3Video;
  resourceId?: number | null;
  resourceType?: string | null;
  url?: string | null;
  additionalResourceData?: AdditionalResourceData;
  trackingId?: string;
}

export interface Row {
  id?: number;
  position: number;
  type: string;
  elements: Element[];
  mobileRatio?: number;
  doubleTileShifted?: boolean;
  desktopRatio?: number;
  rowsCount?: number;
  layoutOrder?: Layout;
}

export interface Story {
  id: number;
  type: string;
  name: string;
  color: string;
  gender?: string;
  initialAppId: number;
  resourceId?: number;
  resourceType?: string;
  contentType?: string;
  headline?: object;
  subline?: object;
  headlineLong?: object;
  sublineLong?: object;
  age_from?: number;
  age_to?: number;
  clusters?: number[] | Cluster[];
  appConfigs: AppConfig[];
  rows: Row[];
  ownerImage: MediaItem;
  headerImageBrandId?: number | null;
  largerDesktopTeaser: boolean;
  appImage: MediaItem;
  mobileImage: MediaItem;
  desktopImage: MediaItem;
  isPrimary: boolean;
  isSponsored: boolean;
  isBasSponsored: boolean;
  isSale: boolean;
  isPremium: boolean;
  isHidden: boolean;
  isProductRowDisabled: boolean;
  isSecondhand: boolean;
  edited?: boolean;
  clusterStory?: StoryClusterPivot;
}

export interface StoryClusterPivot {
  position: number;
}

export interface Stories {
  byId: {
    [key: number]: Story;
  };
  edited?: Story;
}

export type StoryState = Stories & ImmutableObject<Stories>;

const initialState = Immutable.from<Stories>({
  byId: {},
});
export default function reduce(
  state: StoryState = initialState,
  action: Action
) {
  if (isType(action, updateStories)) {
    return state.merge(
      {
        byId: action.payload,
      },
      { deep: true }
    );
  }

  if (isType(action, singleStoryFetched)) {
    return state.merge({ edited: action.payload }, { deep: true });
  }

  return state;
}

export const getStoriesByIds = (state: AppState, ids: number[]) => {
  const {
    entities: { stories },
  } = state;
  return (
    ids &&
    ids.map(id => {
      return stories && stories.byId && stories.byId[id];
    })
  );
};



// WEBPACK FOOTER //
// ./src/store/Entities/Stories/stories.reducer.ts